import { EndpointSetting } from "@/constants/app/type"
import { BookingState } from "../type"

export const callbackCreateOrder: EndpointSetting['caller'] = (
  state: BookingState,
  action: any,
  endpointName: any
) => {
  state.flight_create_order.loading = false
  state.flight_create_order.error = null
  state.flight_create_order.success = true
  state.flight_create_order.data = action.payload

  state.order_detail.data = action.payload?.data

  localStorage.setItem('orderExpiryDate',  action.payload?.data?.tickets?.[0]?.expiryDate || '')
}